import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import {
  FormikAutocompleteInput,
  FormikDateInput,
} from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHFeriadoSerieIns } from "services/services-mia/programa-salud/feriados/RNHFeriadoSerieIns";
import { RNHFeriadoGet } from "services/services-mia/programa-salud/feriados/RNHFeriadoGet";

/**
 * Alta de UNA fecha para un feriado ya existente.
 *
 * El servicio toma una sola `rnhFeriadoSerieFecha`, así que el modal carga de a una.
 * Para los feriados que se repiten todos los años, se repite el alta una vez por año.
 */
export default function InsertModal({ updateList, closeModal }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const [feriados, setFeriados] = useState([]);
  const [cargandoFeriados, setCargandoFeriados] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: result } = await RNHFeriadoGet(credentials);
      // Sin esto el select lista la fila centinela del back como si fuera una opcion.
      setFeriados(result?.[0]?.rnhFeriadoId ? result : []);
      setCargandoFeriados(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const crearFecha = async (values) => {
    setInRequest(true);
    const response = await RNHFeriadoSerieIns(credentials, {
      feriadoId: values.feriadoId,
      fecha: values.fecha,
    });
    setInRequest(false);

    if (!response.ok) return;

    setSnackBarInfo({
      message: "Fecha agregada correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList();
    closeModal();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        feriadoId: "",
        fecha: "",
      }}
      validationSchema={yup.object({
        // Los dos son obligatorios: una fecha suelta sin feriado no significa nada, y
        // un feriado sin fecha es justamente lo que ya existe en la otra vista.
        feriadoId: yup.string().required("Debe elegir un feriado"),
        fecha: yup.string().required("Debe ingresar una fecha"),
      })}
      onSubmit={(values) => {
        crearFecha(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={8}>
              {/* Con buscador y no un <select> comun: la lista de feriados crece
                  sola y encontrar uno escribiendo es mas rapido que recorrerla.
                  No lleva opcion "Seleccione": el placeholder "Buscar..." del
                  componente ya dice que hacer, y el campo arranca vacio. */}
              <FormikAutocompleteInput
                name="feriadoId"
                labelText="Feriado"
                options={feriados}
                optionValue="rnhFeriadoId"
                optionLabel="rnhFeriadoNombre"
                disabled={cargandoFeriados}
              />
            </Grid>
            <Grid item xs={4}>
              <FormikDateInput name="fecha" labelText="Fecha" />
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest || cargandoFeriados}
            newFormData={{ button: "Crear" }}
            onCloseModal={closeModal}
          />
          {(inRequest || cargandoFeriados) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
